const env = import.meta.env
export const API_URL = env.VITE_API_URL;
